const compatModules = {};import * as Mod1 from "./discourse/components/upsert-category-ideas";
compatModules["discourse/components/upsert-category-ideas"] = Mod1;

export * as discourse$components$upsert__category__ideas$$__module from "./discourse/components/upsert-category-ideas";
export {
default as discourse$components$upsert__category__ideas$$default
} from "./discourse/components/upsert-category-ideas";
import * as Mod2 from "./discourse/components/vote-box";
compatModules["discourse/components/vote-box"] = Mod2;

export * as discourse$components$vote__box$$__module from "./discourse/components/vote-box";
export {
default as discourse$components$vote__box$$default
} from "./discourse/components/vote-box";
import * as Mod3 from "./discourse/components/vote-button";
compatModules["discourse/components/vote-button"] = Mod3;

export * as discourse$components$vote__button$$__module from "./discourse/components/vote-button";
export {
default as discourse$components$vote__button$$default
} from "./discourse/components/vote-button";
import * as Mod4 from "./discourse/components/vote-count-trigger";
compatModules["discourse/components/vote-count-trigger"] = Mod4;

export * as discourse$components$vote__count__trigger$$__module from "./discourse/components/vote-count-trigger";
export {
default as discourse$components$vote__count__trigger$$default
} from "./discourse/components/vote-count-trigger";
import * as Mod5 from "./discourse/components/vote-count";
compatModules["discourse/components/vote-count"] = Mod5;

export * as discourse$components$vote__count$$__module from "./discourse/components/vote-count";
export {
default as discourse$components$vote__count$$default
} from "./discourse/components/vote-count";
import * as Mod6 from "./discourse/connectors/category-custom-settings/feature-voting-settings-upsert.gjs";
compatModules["discourse/connectors/category-custom-settings/feature-voting-settings-upsert"] = Mod6;

export * as discourse$connectors$category__custom__settings$feature__voting__settings__upsert$$__module from "./discourse/connectors/category-custom-settings/feature-voting-settings-upsert.gjs";
export {
default as discourse$connectors$category__custom__settings$feature__voting__settings__upsert$$default
} from "./discourse/connectors/category-custom-settings/feature-voting-settings-upsert.gjs";
import * as Mod7 from "./discourse/connectors/category-custom-settings/feature-voting-settings.gjs";
compatModules["discourse/connectors/category-custom-settings/feature-voting-settings"] = Mod7;

export * as discourse$connectors$category__custom__settings$feature__voting__settings$$__module from "./discourse/connectors/category-custom-settings/feature-voting-settings.gjs";
export {
default as discourse$connectors$category__custom__settings$feature__voting__settings$$default
} from "./discourse/connectors/category-custom-settings/feature-voting-settings.gjs";
import * as Mod8 from "./discourse/connectors/header-topic-info__before/header-topic-voting.gjs";
compatModules["discourse/connectors/header-topic-info__before/header-topic-voting"] = Mod8;

export * as discourse$connectors$header__topic__info__before$header__topic__voting$$__module from "./discourse/connectors/header-topic-info__before/header-topic-voting.gjs";
export {
default as discourse$connectors$header__topic__info__before$header__topic__voting$$default
} from "./discourse/connectors/header-topic-info__before/header-topic-voting.gjs";
import * as Mod9 from "./discourse/connectors/topic-title/topic-title-voting.gjs";
compatModules["discourse/connectors/topic-title/topic-title-voting"] = Mod9;

export * as discourse$connectors$topic__title$topic__title__voting$$__module from "./discourse/connectors/topic-title/topic-title-voting.gjs";
export {
default as discourse$connectors$topic__title$topic__title__voting$$default
} from "./discourse/connectors/topic-title/topic-title-voting.gjs";
import * as Mod10 from "./discourse/connectors/user-activity-bottom/user-voted-topics.gjs";
compatModules["discourse/connectors/user-activity-bottom/user-voted-topics"] = Mod10;

export * as discourse$connectors$user__activity__bottom$user__voted__topics$$__module from "./discourse/connectors/user-activity-bottom/user-voted-topics.gjs";
export {
default as discourse$connectors$user__activity__bottom$user__voted__topics$$default
} from "./discourse/connectors/user-activity-bottom/user-voted-topics.gjs";
import * as Mod11 from "./discourse/feature-voting-route-map";
compatModules["discourse/feature-voting-route-map"] = Mod11;

export * as discourse$feature__voting__route__map$$__module from "./discourse/feature-voting-route-map";
export {
default as discourse$feature__voting__route__map$$default
} from "./discourse/feature-voting-route-map";
import * as Mod12 from "./discourse/initializers/discourse-topic-voting";
compatModules["discourse/initializers/discourse-topic-voting"] = Mod12;

export * as discourse$initializers$discourse__topic__voting$$__module from "./discourse/initializers/discourse-topic-voting";
export {
default as discourse$initializers$discourse__topic__voting$$default
} from "./discourse/initializers/discourse-topic-voting";
import * as Mod13 from "./discourse/initializers/ideas-category-type-tab";
compatModules["discourse/initializers/ideas-category-type-tab"] = Mod13;

export * as discourse$initializers$ideas__category__type__tab$$__module from "./discourse/initializers/ideas-category-type-tab";
export {
default as discourse$initializers$ideas__category__type__tab$$default
} from "./discourse/initializers/ideas-category-type-tab";
import * as Mod14 from "./discourse/initializers/topic-voting-admin-plugin-configuration-nav";
compatModules["discourse/initializers/topic-voting-admin-plugin-configuration-nav"] = Mod14;

export * as discourse$initializers$topic__voting__admin__plugin__configuration__nav$$__module from "./discourse/initializers/topic-voting-admin-plugin-configuration-nav";
export {
default as discourse$initializers$topic__voting__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/topic-voting-admin-plugin-configuration-nav";
import * as Mod15 from "./discourse/pre-initializers/extend-category-for-voting";
compatModules["discourse/pre-initializers/extend-category-for-voting"] = Mod15;

export * as discourse$pre__initializers$extend__category__for__voting$$__module from "./discourse/pre-initializers/extend-category-for-voting";
export {
default as discourse$pre__initializers$extend__category__for__voting$$default
} from "./discourse/pre-initializers/extend-category-for-voting";
import * as Mod16 from "./discourse/pre-initializers/transformers";
compatModules["discourse/pre-initializers/transformers"] = Mod16;

export * as discourse$pre__initializers$transformers$$__module from "./discourse/pre-initializers/transformers";
export {
default as discourse$pre__initializers$transformers$$default
} from "./discourse/pre-initializers/transformers";
import * as Mod17 from "./discourse/routes/user-activity/votes";
compatModules["discourse/routes/user-activity/votes"] = Mod17;

export * as discourse$routes$user__activity$votes$$__module from "./discourse/routes/user-activity/votes";
export {
default as discourse$routes$user__activity$votes$$default
} from "./discourse/routes/user-activity/votes";
export default compatModules;
